import { createReducer, on } from '@ngrx/store';

import { AuthActions, BasketActions, DataActions } from '../actions';
import { BasketState, FlightBasket } from '../../interfaces';

export const initialState: BasketState = {
  flights: [],
  passengerIds: [],
};

const basketReducer = createReducer(
  initialState,
  on(AuthActions.setBookingRef, AuthActions.logout, DataActions.clearAll, () => initialState),
  on(BasketActions.addPaxToBasket, (state, { passengerId }) => {
    if (state.passengerIds.includes(passengerId)) {
      return state;
    }
    return {
      ...state,
      passengerIds: [...state.passengerIds, passengerId],
    };
  }),
  on(BasketActions.removePassenger, (state, { passengerId }) => ({
    ...state,
    passengerIds: state.passengerIds.filter((passenger) => passenger !== passengerId),
  })),
  on(BasketActions.addFlightToBasket, (state, { flight }) => ({
    ...state,
    flights: [...state.flights, flight],
  })),
  on(BasketActions.removeFlight, (state, { flightId }) => ({
    ...state,
    flights: state.flights.filter((flight) => flight.flightId !== flightId),
  })),
  on(BasketActions.updateFlight, (state, { flight }) => ({
    ...state,
    flights: state.flights.map((stateFlight) => {
      return stateFlight.flightId === flight.flightId ? flight : stateFlight;
    }),
  })),
  on(BasketActions.clearFlights, (state) => ({
    ...state,
    flights: [],
  }))
);

export function reducer(
  state: BasketState,
  action: AuthActions.AuthActionsUnion | BasketActions.BasketActionsUnion | DataActions.DataActionsUnion
): BasketState {
  return basketReducer(state, action);
}

export const getFlights = (state: BasketState): FlightBasket[] => state.flights;
export const getPassengerIds = (state: BasketState): string[] => state.passengerIds;
